export default __webpack_public_path__ + "static/media/Slider1.fc3fc63f.jpg";